import { CellPosition, CellValue, Cells, Sheet } from '../../types';
import {
  SheetManagementSet
} from '../../types/sheet/draft';
import { getCell } from '../cells/cellCRUD';

// #region types
export interface IOnCell {
  sheet: string;
  row: number;
  col: number;
}

interface IFormulaRange {
  row: number;
  col: number;
}
export interface IOnRange {
  sheet: string;
  from: IFormulaRange;
  to: IFormulaRange;
}

export type SheetsDataSetForParser = Pick<
  SheetManagementSet,
  'temporarySheets' | 'draftedSheets'
>;
// export type SheetsDataSetForParser = Partial<SheetsDataSet> &
//   Pick<SheetsDataSet, 'temporarySheets'>;

type SheetDataForCell = Pick<Sheet, 'cols' | 'rows'>; // | 'cells' | 'results'
// #endregion

// #region on cell
export const onCell = (
  { sheet: sheetId, row, col }: IOnCell,
  set?: SheetsDataSetForParser
) => {
  const pos = {
    ri: row - 1,
    ci: col - 1,
  };
  if (!set || !set.temporarySheets?.has(sheetId)) return;
  const cells = getCellsFromSheetsSet(sheetId, set);
  return getCellVisibleValue(cells, pos);
};
// #endregion

// #region onRange
export const onRange = (
  { from, to, sheet: sheetId }: IOnRange,
  set?: SheetsDataSetForParser
) => {
  if (!set || !set.temporarySheets?.has(sheetId)) return;

  const cells = getCellsFromSheetsSet(sheetId, set);

  const colRange = {
    start: from.col - 1,
    end: to.col - 1,
  };
  const rowRange = {
    start: from.row - 1,
    end: to.row - 1,
  };

  const rowEnd = Math.min(cells.length - 1, rowRange.end);
  const colEnd = colRange.end;

  const rangeData = [];
  for (let ri = rowRange.start; ri <= rowEnd; ri++) {
    let rowData = [];
    const rowCells = cells[ri];

    if (!rowCells) {
      rowData.push('');
    } else {
      for (let ci = colRange.start; ci <= colEnd; ci++) {
        rowData.push(getCellVisibleValue(cells, { ci, ri }));
      }
    }

    rangeData.push(rowData);
  }

  return rangeData;
};
// #endregion

// #region helpers
const getCellVisibleValue = (cells: Cells, pos: CellPosition) => {
  let cellValue: CellValue | null = null;

  const cell = getCell(cells, pos);
  if (cell) {
    const result = cell.r;
    const value = cell.v;
    if (result !== undefined) cellValue = result;
    else cellValue = value ?? '';
  }

  return isNaN(Number(cellValue)) ? cellValue : Number(cellValue);
};

const getCellsFromSheetsSet = (
  sheetId: string,
  set: SheetsDataSetForParser
): Cells => {
  const draftedSheet = set.draftedSheets.get(sheetId);
  const sheet = set.temporarySheets.get(sheetId);

  const cells = draftedSheet?.cells ?? sheet?.cells ?? [];

  return cells;
};
// #endregion
